import { Fragment } from "react";
import { NotificationType } from "@/store/useNotificationStore";
import { interpolate } from "@/utils/stringUtils";
import TutorViewNotification from "./TutorViewNotification";
import CountdownDigits from "./CountdownDigits";

export const TUTOR_VIEW_NOTIFICATION_SUPPORTED_TYPES: NotificationType[] = [
  NotificationType.LOCKED,
  NotificationType.NEXT_BITE,
  NotificationType.EXIT_LESSON,
];

const SECONDS_PLACEHOLDER = "{{seconds}}";

interface DynamicTutorViewNotificationProps {
  id: string;
  type: NotificationType;
  titleTemplate?: string;
  titleData?: Record<string, any>;
  durationMs?: number;
  subheading: string;
  onClose?: () => void;
}

const DynamicTutorViewNotification = ({
  id,
  type,
  titleTemplate,
  titleData,
  durationMs,
  subheading,
  onClose,
}: DynamicTutorViewNotificationProps) => {
  const totalSeconds = Math.ceil((durationMs || 0) / 1000);
  const template = titleTemplate || "";
  const data = titleData || {};

  // {{seconds}} is drawn by CountdownDigits rather than interpolated, so the
  // count doesn't depend on React re-rendering every second.
  const title =
    totalSeconds > 0 && template.includes(SECONDS_PLACEHOLDER)
      ? template.split(SECONDS_PLACEHOLDER).map((part, index) => (
          <Fragment key={index}>
            {index > 0 && <CountdownDigits totalSeconds={totalSeconds} />}
            {interpolate(part, data)}
          </Fragment>
        ))
      : interpolate(template, { ...data, seconds: totalSeconds });

  return (
    <TutorViewNotification
      id={id}
      title={title}
      subheading={subheading}
      type={type}
      onClose={onClose}
    />
  );
};

export default DynamicTutorViewNotification;
